export enum AddressType {
  registered = 1, // ที่อยู่ตามทะเบียนบ้าน
  present = 2, // ที่อยู่ปัจจุบัน
  office = 3 // ที่อยู่ที่ทำงาน
}
